<div class="d-flex flex-column flex-auto roi-setting-container">
  <div class="roi-setting">
    <div class="d-flex flex-row align-items-center setting-line">
      <div class="roi-setting-label">
        <label>{{'measure.roi_setting.calculation_method' | translate}}</label>
      </div>
      <div class="roi-setting-field">
        <achoo-filter-box [options]="calculationMethods"
                          [(model)]="roiSetting.calculationMethod"
                          placeholder="{{'measure.roi_setting.calculation_method_placeholder' | translate}}"
                          name="influencer_group_type">
        </achoo-filter-box>
      </div>
    </div>
    <div class="d-flex flex-row align-items-center setting-line">
      <div class="roi-setting-label">
        <label>{{'measure.roi_setting.currencies' | translate}}</label>
      </div>
      <div class="roi-setting-field">
        <achoo-filter-box [options]="currencies"
                          [(model)]="roiSetting.currency"
                          placeholder="{{'measure.roi_setting.currency_placeholder' | translate}}"
                          name="influencer_group_type">
        </achoo-filter-box>
      </div>
    </div>
  </div>
  <div class="seperate-line">
    <div class="seperate-line-inner"></div>
  </div>
  <div class="specific-per-channel">
    <div class="specified-label">
      <span>{{'measure.roi_setting.specific_label' | translate}}</span>
    </div>
    <div class="d-flex flex-row align-items-center setting-line">
      <div class="roi-setting-label">
        <div class="d-flex flex-row">
          <div class="blogs-icon roi-channel-icon"></div>
          <label class="channel-name">{{'measure.roi_setting.blogs' | translate}}</label>
        </div>
      </div>
      <div class="roi-setting-field d-flex flex-row align-items-center">
        <achoo-text-field [placeholder]="'25'"
                          [(model)]="roiSetting.blog">
        </achoo-text-field>
        <span class="currency-label">{{selectedCurrency}}</span>
      </div>
    </div>

    <div class="d-flex flex-row align-items-center setting-line">
      <div class="roi-setting-label">
        <div class="d-flex flex-row">
          <div class="instagram-icon roi-channel-icon"></div>
          <label class="channel-name">{{'measure.roi_setting.instagram' | translate}}</label>
        </div>
      </div>
      <div class="roi-setting-field d-flex flex-row align-items-center">
        <achoo-text-field [placeholder]="'25'"
                          [(model)]="roiSetting.instagram">
        </achoo-text-field>
        <span class="currency-label">{{selectedCurrency}}</span>
      </div>
    </div>
    <div class="d-flex flex-row align-items-center setting-line">
      <div class="roi-setting-label">
        <div class="d-flex flex-row">
          <div class="instagram-icon roi-channel-icon"></div>
          <label class="channel-name">{{'measure.roi_setting.instagram_story' | translate}}</label>
        </div>
      </div>
      <div class="roi-setting-field d-flex flex-row align-items-center">
        <achoo-text-field [placeholder]="'25'"
                          [(model)]="roiSetting.instagramStory">
        </achoo-text-field>
        <span class="currency-label">{{selectedCurrency}}</span>
      </div>
    </div>
    <div class="d-flex flex-row align-items-center setting-line">
      <div class="roi-setting-label">
        <div class="d-flex flex-row">
          <div class="instagram-icon roi-channel-icon"></div>
          <label class="channel-name">{{'measure.roi_setting.instagram_reel' | translate}}</label>
        </div>
      </div>
      <div class="roi-setting-field d-flex flex-row align-items-center">
        <achoo-text-field [placeholder]="'25'"
                          [(model)]="roiSetting.instagramReel">
        </achoo-text-field>
        <span class="currency-label">{{selectedCurrency}}</span>
      </div>
    </div>
    <div class="d-flex flex-row align-items-center setting-line">
      <div class="roi-setting-label">
        <div class="d-flex flex-row">
          <div class="youtube-icon roi-channel-icon"></div>
          <label class="channel-name">{{'measure.roi_setting.youtube' | translate}}</label>
        </div>
      </div>
      <div class="roi-setting-field d-flex flex-row align-items-center">
        <achoo-text-field [placeholder]="'25'"
                          [(model)]="roiSetting.youtube">
        </achoo-text-field>
        <span class="currency-label">{{selectedCurrency}}</span>
      </div>
    </div>
    <div class="d-flex flex-row align-items-center setting-line">
      <div class="roi-setting-label">
        <div class="d-flex flex-row">
          <div class="tiktok-icon roi-channel-icon"></div>
          <label class="channel-name">{{'measure.roi_setting.tiktok' | translate}}</label>
        </div>
      </div>
      <div class="roi-setting-field d-flex flex-row align-items-center">
        <achoo-text-field [placeholder]="'25'"
                          [(model)]="roiSetting.tiktok">
        </achoo-text-field>
        <span class="currency-label">{{selectedCurrency}}</span>
      </div>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/main/measure/content/roi-report/roi-setting/roi-setting.component.html